<template>
  <div class="yimiao article">
    <div class="article_bigBox">
      <div>
        <van-cell-group>
          <van-field v-model="datafrom.title" required label="标题" placeholder="请输入标题"  style="border: none;"/>
        </van-cell-group>
        <van-cell-group>
          <van-field required v-model="datafrom.TKName" @click="fuwushow = true" readonly="readonly" label="资讯类别"
            placeholder="请选择资讯类别" />
          <van-popup v-model="fuwushow" position="bottom" get-container="body">
            <van-picker show-toolbar :columns="fuwuLists" value-key="name" @cancel="fuwushow = false"
              @confirm="onfuwushow">
            </van-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="datafrom.IssTime" name="IssTime" label="发布时间" @click="StartTimeFend = true"
            readonly="readonly" placeholder="请选择发布时间" />
          <van-popup v-model="StartTimeFend" position="bottom" get-container="body">
            <van-datetime-picker v-model="currentDate" type="datetime" title="请选择发布时间" @cancel="StartTimeFend = false"
              @confirm="onStartTimeFend">
            </van-datetime-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="datafrom.Summary" label="概述" placeholder="请输入概述" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="datafrom.Remark" label="备注" placeholder="请输入备注" />
        </van-cell-group>
        <div class="addBox">
          <span style="font-size: 14px; color: #333; margin: 0 17px">状态</span>
          <van-radio-group class="addBox_box"  v-model ="datafrom.Status">
            <van-radio name="1" style="margin-right: 10px;">启用</van-radio>
            <van-radio name="2">禁用</van-radio>
          </van-radio-group>
        </div>
        <div style="margin-top: 15px;">
          <span style="font-size: 14px; color: #333; margin: 0 17px">主题图片</span>
          <div>
            <van-uploader v-model="fileList"  class="imgActivity" :max-count="1"  :after-read="afterRead"
            :deletable="true" @delete="shanchu" style="margin: 15px 18px 0" />
          </div>
        </div>
        <van-cell-group>
          <div class="activity-title">资讯信息</div>
          <div>
            <Editor :value.sync="datafrom.Content" style="width: 100%" />
          </div>
        </van-cell-group>

      </div>
      <div class="buttons">
        <van-button type="info" style="margin: 20px 0" @click="postfrom()">发布</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Dialog } from "vant";
import { Toast } from "vant";
import { getNickName, setToken } from "@/utils/auth";
import { GetOrganTree } from "@/api/Organ";
import { SaveDynamic, WeGetInfoKindInfoPage } from "@/api/RealInfo";
import { GetInfoKindInfoPage,SaveRlInfo } from "@/api/Changan-zhsq/NewsArticles";
Vue.use(Toast);
import {
  WeGetRegionList,
  WeGetBuildRoomList,
  WeGetAppletOrganList,
} from "@/api/yeguang";
import axios from "axios";
import config from "@/config";
import {
  WeSaveStaServiceSort,
  WeSaveProService,
  WeGetStaServiceSortPage,
} from "@/api/Lycal";
import Editor from "@/components/Editor";
import wx from "weixin-js-sdk";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Editor,
  },
  data() {
    return {
      ridlist: [],
      BRIdlist: [],
      fuwuLists: [],
      SerKindlist: [
        { value: 1, Name: "助餐" },
        { value: 2, Name: "助洁" },
        { value: 3, Name: "助行" },
        { value: 4, Name: "助浴" },
        { value: 5, Name: "助医" },
        { value: 6, Name: "康复" },
        { value: 7, Name: "巡访关爱" },
        { value: 8, Name: "辅助租赁" },
        { value: 99, Name: "其他" },
      ],
      idList: {
        organCode: "",
        // RId: undefined,
      },
      datafrom: {
        // Id: 0, //
        Thematic: '',
        title: '',
        TKName: "",
        TKId: "",
        IssTime:'',
        Summary:'',
        Content:'',
        Remark:'',
        Status: '1'
      },
      idListRId: false,
      fuwushow: false,
      sexshow: false,
      fileList: [],
      uploadImgs: [],
      TitleList: [], // 资讯分类
      timeList: [
        {
          id: 1,
          name: "长期有效",
        },
        {
          id: 2,
          name: "限定时间",
        },
      ], // 时间限制
      timeLimit: false,
      signup: false,
      StartTimeFend: false,
      IssTimeFend: false,
      EndTimeFend: false,
      currentDate: new Date(),
      currentDate1: new Date(),
      currentDate3: new Date(),
      SignupTypelist: [
        { id: 1, name: "报名参加" },
        { id: 2, name: "仅通知" },
      ], // 报名类型
      openid: ''
    };
  },
  created() {
    this.getKind()
    this.openid = JSON.parse(this.$route.query.openid);
    console.log(this.openid)
    // this.datafrom = dataFrom;
  },
  methods: {
    getKind() {
      this.loading = true;
      GetInfoKindInfoPage({ PAKind: 1 })
        .then((res) => {
          console.log(res.data)
          if (res.data.code === 0) {
            this.fuwuLists = res.data.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onStartTimeFend(val) {
      //发布时间确认
      this.datafrom.IssTime = this.formatDateTime(val);
      console.log(this.datafrom.IssTime)
      this.StartTimeFend = false;
    },
    onEndTimeFend(val) {
      //发布时间确认
      this.datafrom.EndTime = this.dateformat(val);
      this.EndTimeFend = false;
    },
    onIssTimeFend(val) {
      //发布时间确认
      this.datafrom.IssTime = this.dateformat1(val);
      this.IssTimeFend = false;
    },
     formatDateTime(val) {
  // 如果 val 是字符串，先转为 Date 对象
  if (typeof val === 'string') {
    val = new Date(val);
  }

  const year = val.getFullYear();
  const month = val.getMonth() + 1; // 月份从0开始
  const day = val.getDate();
  const hour = val.getHours();
  const minute = val.getMinutes();
  const second = val.getSeconds();

  // 补零函数
  const padZero = (num) => (num < 10 ? `0${num}` : num);

  return `${year}-${padZero(month)}-${padZero(day)} ${padZero(hour)}:${padZero(minute)}:${padZero(second)}`;
},
    dateformat(val) {
      // 时间格式化事件 yy-mm-dd
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      return `${year}-${month}-${day} ` ;
    },
    // 上传 相关
    handleAvatarSucces(file) {
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          Toast.success("上传成功");
          //   var arr = this.uploadImgs;
          //   arr.push(res.data.data);
          //   this.uploadImgs = arr;
        }
        this.datafrom.Video = res.data.msg;
      });
    },
    // 图片上传
    afterRead(file) {
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          var arr = this.uploadImgs;
          arr.push(res.data.msg);
          this.uploadImgs = arr;
        }
        this.datafrom.Imgs = this.uploadImgs + "";
      });
    },
    // 图片删除
    shanchu: function (file, detail) {
      this.uploadImgs.splice(detail.index, 1);
      this.datafrom.Imgs = this.uploadImgs + "";
    },

    // 提交
    postfrom: function () {
      console.log(this.datafrom);
      if (!this.datafrom.TKName) {
        Toast.fail("请选择动态类型");
        return false;
      }
      if (!this.datafrom.title) {
        Toast.fail("请输入动态标题");
        return false;
      }
      // if (this.datafrom.IssTime == false) {
      //   Toast.fail("请选择发布时间");
      //   return false;
      // }
      // this.datafrom.IssMan = getNickName();
      this.datafrom.Thematic = this.datafrom.Imgs
      this.datafrom.PAKind = 1
      this.datafrom.RIId = 0
      this.datafrom.openId = this.openid
      console.log(this.datafrom, "this.datafrom");
      SaveRlInfo(this.datafrom).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          Toast.success("发布成功");
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
              window.wx.miniProgram.reLaunch({
                url: "../public/goto?path=/activity",
              });
            } else {
              this.$router.go(-1);
            }
          }, 1000);
          //   Dialog.alert({
          //     title: "提示",
          //     message: "提交成功!",
          //   }).then(() => {
          //     this.$router.push({
          //       path: "/CalYl/service",
          //     });
          //   });
        } else {
          Toast(res.data.msg);
          //   this.$router.go(-1);
        }
      });
    },
    fanhui: function () {
      this.$router.push({
        name: "/CalYl/service",
      });
    },
    // 服务类型选择器
    onsexshow(val) {
      this.datafrom.SerKind = val.value;
      this.datafrom.SerKindDesc = val.Name;
      this.sexshow = false;
    },
    // 动态类型选择器
    onfuwushow(val) {
      console.log(val);
      this.datafrom.TKId = val.pakind;
      this.datafrom.TKName = val.name;
      this.fuwushow = false;
    },
    // 时间限制选择器
    onTimeLimit(val) {
      console.log(val);
      this.datafrom.TimeLimit = val.id;
      this.datafrom.TimeLimitName = val.name;
      this.timeLimit = false;
    },
    // 报名类型选择器
    onSignup(val) {
      console.log(val);
      this.datafrom.SignupType = val.id;
      this.datafrom.SignupTypeName = val.name;
      this.signup = false;
    },
    // 小区(组)列表
    RegionList: function (row) {
      WeGetRegionList({ organCode: row }).then((res) => {
        this.ridlist = res.data.data;
      });
    },
    // 房屋列表
    BuildRoomList: function (val) {
      WeGetBuildRoomList({
        bId: this.idList.BId,
        buId: this.idList.buId,
        bfId: val,
      }).then((res) => {
        console.log(res);
        this.BRIdlist = res.data.data;
      });
    },
    // 小区(组)选择器
    onidListRId(val) {
      this.datafrom.RId = val.RId;
      this.datafrom.Region = val.Title;
      this.idListRId = false;
      this.BuildList(val.RId);
    },
    dateformat1(val) {
      // 时间格式化事件 yy-mm-dd
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let houser = val.getHours();
      let Minutes = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (houser >= 1 && houser <= 9) {
        houser = `0${houser}`;
      }
      if (Minutes >= 1 && Minutes <= 9) {
        Minutes = `0${Minutes}`;
      }
      return `${year}-${month}-${day} ${houser}:${Minutes}` + ":00";
    },
  },
};
</script>
<style>
.article{
  /* background: linear-gradient(91deg, #E4F6FC 0%, #D5DBF8 100%); */
  background-image: url('https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/26c9.png');
background-position: top;
background-size: contain;
background-repeat: no-repeat;
background-color: #f7f7f7;
padding: 15px;
width: auto !important;
}
.article_bigBox{
  /* width:calc(100% - 46px); */
  /* margin: 0 auto; */
  background-color: #fff;
  border-radius: 16px;
  padding: 2px 8px 20px;
}
.yimiao .inputFrom {
  margin: 15px 8%;
}

.yimiao .inputFrom input {
  width: 80%;
  margin: 8px 8%;
  padding: 8px 5px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  text-align: right;
}
.article  .van-field__control{
  text-align: right;
}

.yimiao .buttons {
  text-align: center;
}

.yimiao .buttons button {
  width: 90%;
  margin: 25px 5%;
  border-radius: 10px;
}

.buttons {
  text-align: center;
}

.buttons button {
  margin: 25px 10px;
  border-radius: 10px;
}

.imgActivity {
  vertical-align: middle;
}
.imgActivity .van-uploader__upload{
  border: 1px dashed #ccc;
}

.activity-title {
  color: #646566;
  text-align: left;
  font-size: 14px;
  padding: 10px 16px;
}

.addBox {
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;
}

.addBox_box {
  display: flex;
  align-items: center;
}
 .article  .van-cell::after {
    border-bottom: 1px solid #EFEFEF;
}
.article  .van-cell:first::after {
  border-top:none ;
    border-bottom: 1px solid #EFEFEF;
}
.article .van-hairline--top-bottom::after, .article .van-hairline-unset--top-bottom::after{
  border:none;
  border-bottom: 1px solid #EFEFEF;
}
</style>
